function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPicmeHamburger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 19 19"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.5C0 .7.7 0 1.5 0h16c.8 0 1.5.7 1.5 1.5S18.3 3 17.5 3h-16C.7 3 0 2.3 0 1.5m0 8C0 8.7.7 8 1.5 8h16c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-16C.7 11 0 10.3 0 9.5M1.5 16c-.8 0-1.5.7-1.5 1.5S.7 19 1.5 19h16c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0010a5"
  }
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "picme-hamburger_svg__a",
  cx: -32.895,
  cy: 64.895,
  r: 1,
  gradientTransform: "matrix(0 9.5 9.5 0 -607 322)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  style: {
    stopColor: "#0d5fff"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.359,
  style: {
    stopColor: "#ff3d00"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  style: {
    stopColor: "#ffcc63"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  style: {
    stopColor: "#51db3c"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.5C0 .7.7 0 1.5 0h16c.8 0 1.5.7 1.5 1.5S18.3 3 17.5 3h-16C.7 3 0 2.3 0 1.5m0 8C0 8.7.7 8 1.5 8h16c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-16C.7 11 0 10.3 0 9.5M1.5 16c-.8 0-1.5.7-1.5 1.5S.7 19 1.5 19h16c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#picme-hamburger_svg__a)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "picme-hamburger_svg__b",
  x1: 3.157,
  x2: 15.837,
  y1: -4.843,
  y2: 7.837,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0014cb"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.094,
  style: {
    stopColor: "#0614cc"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.221,
  style: {
    stopColor: "#1712d0"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.366,
  style: {
    stopColor: "#3410d6"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526,
  style: {
    stopColor: "#5b0dde"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.697,
  style: {
    stopColor: "#8e09e9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  style: {
    stopColor: "#cb04f5"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#fa00ff"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.5C0 .7.7 0 1.5 0h16c.8 0 1.5.7 1.5 1.5S18.3 3 17.5 3h-16C.7 3 0 2.3 0 1.5",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#picme-hamburger_svg__b)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "picme-hamburger_svg__c",
  x1: 2.498,
  x2: 15.178,
  y1: 2.498,
  y2: 15.178,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0014cb"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#fa00ff"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 9.5C0 8.7.7 8 1.5 8h16c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-16C.7 11 0 10.3 0 9.5",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#picme-hamburger_svg__c)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "picme-hamburger_svg__d",
  x1: 2.233,
  x2: 15.209,
  y1: 11.431,
  y2: -0.946,
  gradientTransform: "matrix(1 0 0 -1 0 22)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0014cb"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.163,
  style: {
    stopColor: "#400fd8"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.327,
  style: {
    stopColor: "#780ae4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.485,
  style: {
    stopColor: "#a707ee"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.636,
  style: {
    stopColor: "#cb04f5"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  style: {
    stopColor: "#e502fb"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.901,
  style: {
    stopColor: "#f500fe"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#fa00ff"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 16c-.8 0-1.5.7-1.5 1.5S.7 19 1.5 19h16c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#picme-hamburger_svg__d)"
  }
}));
export default SvgPicmeHamburger;